/**
 * @generated SignedSource<<1cbcf674c79a723bbdaf7b5e888d1241>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserInput = {
  clientMutationId?: string | null | undefined;
  patch: UserPatch;
  rowId: any;
};
export type UserPatch = {
  firstName?: string | null | undefined;
  isEmailMarketingEnabled?: boolean | null | undefined;
  isEmailNotificationsEnabled?: boolean | null | undefined;
  isMetricSystem?: boolean | null | undefined;
  lastName?: string | null | undefined;
  offerCodes?: ReadonlyArray<string | null | undefined> | null | undefined;
  rowId?: any | null | undefined;
  scheduledDeletionAt?: any | null | undefined;
};
export type useSetUserEmailMarketingEnabledMutation$variables = {
  input: UpdateUserInput;
};
export type useSetUserEmailMarketingEnabledMutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly isEmailMarketingEnabled: boolean;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useSetUserEmailMarketingEnabledMutation = {
  response: useSetUserEmailMarketingEnabledMutation$data;
  variables: useSetUserEmailMarketingEnabledMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEmailMarketingEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetUserEmailMarketingEnabledMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSetUserEmailMarketingEnabledMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b13ba60bbccbd170500d608004c5a71",
    "id": null,
    "metadata": {},
    "name": "useSetUserEmailMarketingEnabledMutation",
    "operationKind": "mutation",
    "text": "mutation useSetUserEmailMarketingEnabledMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      isEmailMarketingEnabled\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8460feb586978553fc490a2a0f626c50";

export default node;
